/**
 * @author xyguo
 * @description 角色管理==》人员维护==》添加人员管理页面,可在该角色下添加人员
 * @Date 2020/1/2
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool, utils_tool } from "@/tool";
import ListSelect from "./listSelect";
import RoleUserImport from "./roleUserImport";
import { modelUtils } from "../../../../../utils";

let { $$ } = utils_tool;
const { WizContainer, WizReduxTemplate } = framework_tool;
const {
  WizTabs
} = component_tool;

class RoleUserAddList extends WizContainer {
  componentName = "RoleUserAddList";

  constructor(props) {
    super(props);
    this.state = {
      selectedRows: [],
      tabKey:1
    };
  }

  static defaultProps = {
    _ok: this._ok
  };



  /**
   * modal框的确定按钮触发
   * 可以在里面增加关闭modal前的操作及校验
   */
  _ok = (data) => {
    let tabKey = this.state.tabKey;
    const { roleId } = data;
    if (tabKey == 1) {
      let listDate = this.state.selectedRows;
      const personIds = [];
      if (!listDate || ($$.isArray(listDate) && !(listDate).length)) {
        wizNotice.warn("请先选择用户");
      } else {
        listDate.forEach(recordData => {
          personIds.push(
            recordData.personId
          )
        });
        this.doAction({
          path: "roleUser/addUsersForRole",
          payload: {
            key: "addUsersForRoleKey",
            apiParams: {
              "roleId": roleId,
              "personIds": personIds
            }
          }
        });
      }
    }else if (tabKey == 2) {
      let userNames = this.state.userNames;
      let userNameArray = userNames? userNames.split("\n") : undefined;
      if( !userNameArray || userNameArray.length==0){
        wizNotice.warn("请先添加用户");
      }else if(userNameArray.length>100){
        wizNotice.warn("添加用户过多,请调整后重试");
      } else{
        this.doAction({
          path: "roleUser/addUsersForRoleByUserName",
          payload: {
            key: "addUsersForRoleKey",
            apiParams: {
              "roleId": roleId,
              "userNames": userNameArray
            }
          }
        });
      }

    }

  };

  updateRows = rows => {
    this.setState({
      rowData: new Date().getTime(),
      selectedRows: rows
    });
  };

  handleClear(id) {
    const { selectedRows } = this.state;
    id
      ? this.setState({
        selectedRows: selectedRows.filter(item => item.id !== id)
      })
      : this.setState({
        selectedRows: []
      });
  }

  _handldImport(nextProps, nextState) {
    let o = nextProps['roleUserImports']
    if (o['success']) {
      let data = o['data'];
      let str = data.replace(/<br\/>/g,"\n")
      wizNotice.success({
        key:'default',
        message:'成功',
        description: (
          <div>
            <p style={{whiteSpace: "pre-line"}}>{str}</p>
          </div>
        ),
      })
      this.setState({tabKey:3});
      this.props.changeModal(false, true);
      return true;
    } else {
      wizNotice.error("导入数据出错，请联系相关人员")
      this.setState({tabKey:3});
      this.props.changeModal(false, true);
      return false;
    }
  }

  propsAndStateOnChange = {
    roleUserAddResult: this._setRoleUserAddState.bind(this),
    roleUserImports: this._handldImport.bind(this),
 //   addUsersForRoleByUserNameKey : this._setRoleUserAddByUserNamesState.bind(this)
  };

  _setRoleUserAddState(nextProps, nextState) {
    if (nextProps.roleUserAddResult.code === 1) {
      wizNotice.success("操作成功");
      this.props.changeModal(false, true);
    } else {
      wizNotice.error(nextProps.roleUserAddResult.msg);
    }
  }

  _setRoleUserAddByUserNamesState(nextProps, nextState) {
    if (nextProps.addUsersForRoleByUserNameKey.code === 1) {
      wizNotice.success("操作成功");
      this.props.changeModal(false, true);
    } else {
      wizNotice.error(nextProps.addUsersForRoleByUserNameKey.msg);
    }
  }

  _onChange = (key) => {
    this.setState({ tabKey: key });
  }

  checkUsers = (values) => {
    this.setState({ userNames: values });

  }

  _render() {
    // let record = this.props.location.record;
    const roleId = this.props.roleId;
    return (
      <WizTabs animated={false} defaultActiveKey="1" onChange={this._onChange.bind(this)}>
        <WizTabs.TabPane tab="查找人员" key="1">
          <ListSelect
            selectedRows={this.state.selectedRows}
            updateRows={rows => this.updateRows(rows)}
            handleClear={id => this.handleClear(id)}
            roleId={this.props.roleId}
          />
        </WizTabs.TabPane>

        {/* 功能暂先不做,临时屏蔽
        <WizTabs.TabPane tab="批量添加" key="2">
          功能待完善...
          <RoleUserBatchAdd checkUsers={this.checkUsers} />
        </WizTabs.TabPane> */}

        <WizTabs.TabPane tab="导入人员" key="3">
        <RoleUserImport roleId={roleId}/>
        </WizTabs.TabPane>
      </WizTabs>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { roleUser } = state;
  const roleUserAddResult = modelUtils.getModelEntity(roleUser, 'addUsersForRoleKey');
  const roleUserImports = modelUtils.getModelEntity(roleUser, 'import');
  //获取loading的方式
  const load = modelUtils.getLoadingState(state, 'roleUser')

  return {
    roleUserAddResult: roleUserAddResult,
    roleUserImports: roleUserImports,
    ...load
  };
};

const options = { withRef: true };

export default connect(mapStateToProps, null, null, options)(RoleUserAddList);
